import "./Signupimage.css";
function Signupimage() {
    return <>
    <div id="Sign-up-image-left-image">
        <div>
            <img className="desk-img" src="./assets/images/illustration-sign-up-desktop.svg" alt="Sign Up"/>
            <img className="mobl-img" src="./assets/images/illustration-sign-up-mobile.svg" alt="Sign Up"/>
        </div>
    </div>
    </>
}

export default Signupimage;